import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Image from 'next/image';

export const NavigationCategories = ({
  categories,
  handleSelectCategory,
  rtl,
}: {
  rtl: boolean;
  categories: any[];
  handleSelectCategory: (category: { [key: string]: string | number }) => void;
}) => {
  const renderIcon = ({ icon, iconColor, title, tourId }: { icon: string | null; iconColor: string | null; title: string; tourId: number }) => {
    if (!icon) {
      return <Image width="27px" height="27px" src="/navigation/default-category.svg" alt={title} />;
    }
    if (icon.endsWith('.webp')) {
      const iconSrc = `${process.env.REACT_APP_AWS}/tours/${tourId}/navigation/icons/${icon}`;
      return <img width="27px" height="27px" src={iconSrc} alt={title} />;
    }
    const iconSrc = `${process.env.REACT_APP_DOMAIN || 'http://localhost:5030'}/v1/public/icons/${icon}?hex=${encodeURIComponent(iconColor)}`;
    return <img width="27px" height="27px" src={iconSrc} alt={title} />;
  };

  return (
    <Stack direction="row" gap="10px" flexWrap="wrap" justifyContent={{ xs: 'space-between', lg: 'flex-start' }} alignItems="center" px={{ xs: '14px', lg: 'unset' }}>
      {categories.map((category) => {
        return (
          <Stack
            key={category.id}
            width={{ xs: '114px', lg: '154px' }}
            height={{ xs: '114px', lg: '154px' }}
            gap={2}
            alignItems="center"
            justifyContent="flex-start"
            p={{ xs: '10px', lg: '30px 14px' }}
            overflow="hidden"
            sx={{
              borderRadius: '8px',
              border: '1px solid #D0D5DD',
              background: '#FFF',
              cursor: 'pointer',
            }}
            onClick={() => handleSelectCategory(category)}
          >
            <Stack width="38px" height="38px" sx={{ background: category.backgroundColor || '#2055FF', borderRadius: '8px', p: '6px 5px' }}>
              {renderIcon(category)}
            </Stack>
            <Typography fontSize={{ xs: '13px', lg: '16px' }} fontWeight={500} textAlign="center" whiteSpace="break-spaces">
              {category.title}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
};
